import { format } from 'd3-format';

import './styles/graphic.scss';
import { classify } from './utils/helpers';

export default function (props, container, isMobile) {
  const {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    xTime,
    y,
    xAxis,
    yAxis,
    margins,
    recessionData,
  } = props;

  const yTicks = isMobile ? 8 : 11;
  const fmtComma = format(',');
  const fmtSI = format('.2s');

  const ticksMobi = ['2007-01-01', '2008-01-01', '2010-01-01', '2012-01-01', '2014-01-01', '2016-01-01', '2018-01-01', '2020-01-01'];
  const ticksDesk = ['2007-01-01', '2008-01-01', '2009-01-01', '2010-01-01', '2011-01-01', '2012-01-01', '2013-01-01', '2014-01-01', '2015-01-01', '2016-01-01', '2017-01-01', '2018-01-01', '2019-01-01', '2020-01-01'];

  /** SET FOR RELEASE (date must match data) * */
  const selectedDate = '2020-04-01';
  const selectText = '-32.9%';
  const selectText2 = 'Q2';

  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  const xGrid = g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(${[0, height]})`)
    .call(xAxis(x)
      .tickValues(isMobile ? ticksMobi : ticksDesk)
      .tickFormat(d => (isMobile ? `\u0027${String(d).substring(2, 4)}` : `\u0027${String(d).substring(2, 4)}`)));

  xGrid.selectAll('text')
    .attr('y', 10);

  const yGrid = g.append('g')
    .attr('class', 'y grid')
    .call(yAxis(y)
      .ticks(yTicks)
      .tickSize(-width)
      .tickFormat(d => (isMobile
        ? (Math.abs(d) > 999
          ? fmtSI(d).toUpperCase()
          : `${`${fmtComma(d)}%`}`
        )
        : (Math.abs(d) > 9999
          ? fmtSI(d).toUpperCase()
          : `${`${fmtComma(d)}%`}`
        ))));

  yGrid.selectAll('text')
    .attr('x', -5)
    .filter(d => d === 0)
    .text(0);
  // .remove(); // hide zero

  const group = g.append('g')
    .attr('class', 'data');

  const recessions = g.append('g')
    .attr('class', 'recessions');

  recessions.selectAll('.recession')
    .data(recessionData)
    .enter().append('rect')
    .attr('class', 'recession')
    .attr('transform', d => `translate(${[xTime(d.start), 0]})`)
    .attr('width', d => xTime(d.end) - xTime(d.start))
    .attr('height', height)
    .style('fill', 'grey')
    .style('fill-opacity', 0.10);

  recessions.append('text')
    .attr('class', 'label-recession')
    .attr('transform', `translate(${[xTime(new Date('12/1/07')) + 5, 15]})`)
    .attr('text-anchor', 'start')
    .text('Recession');

  const bars = group.append('g')
    .attr('class', 'bars');

  const labels = group.append('g')
    .attr('class', 'labels');

  const bar = bars.selectAll('.bar')
    .data(data)
    .enter().append('g')
    .attr('class', 'bar')
    .attr('role', 'list')
    .attr('transform', d => `translate(${[x(d.label), y(d.amt < 0 ? 0 : d.amt)]})`);

  bar.append('title')
    .text(d => `${d.label} (${d.amt})`);

  bar.append('rect')
    .attr('class', (d) => {
      const classDate = (d.label === selectedDate ? `data-new-${classify(d.label)}` : `data-${d.label}`);
      const classType = (d.amt >= 0 ? 'data-positive' : 'data-negative');
      return `${classDate} ${classType}`;
    })
    .attr('width', x.bandwidth())
    .attr('height', d => Math.abs(y(d.amt) - y(0)));

  labels.append('text')
    .attr('class', 'label-2020')
    .attr('transform', data[data.length - 1].amt >= 0
      ? `translate(${[x(selectedDate) + x.bandwidth() / 2, y(data[data.length - 1].amt) - 20]})`
      : `translate(${[x(selectedDate) + x.bandwidth() / 2, y(data[data.length - 1].amt) + 18]})`)
    .attr('text-anchor', 'middle')
    .text(selectText)
    .append('tspan')
    .text(selectText2)
    .attr('x', 0)
    .attr('dy', +14);

  if (y.domain()[0] < 0) {
    // zero line
    g.append('line')
      .attr('role', 'presentation')
      .attr('class', 'zero-bar')
      .attr('x1', 0)
      .attr('x2', width)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }
}
